import { Card, CardBody } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';
import type { InvoiceDetail } from '@/api/invoices';
import { useInvoiceTotalPaid } from '@/api/invoices';
import { formatMoney } from '@/lib/format';

/**
 * Totals band — Amount / VAT / Total / Paid as @ui `Stat`s inside a Card. Paid
 * comes from `/invoices/:id/paymented`; while it loads or if it is unavailable
 * we show an em dash rather than a wrong zero. Figures are rendered in the
 * invoice's own `invoice_currency` (backend keeps amount + currency in sync;
 * default VND).
 */
export function InvoiceTotalsCard({ id, detail }: { id: number; detail: InvoiceDetail }) {
  const { data, isError } = useInvoiceTotalPaid(id);
  const paid = isError ? undefined : data?.result?.total_paid;
  const currency = detail.invoice_currency;

  return (
    <Card flat>
      <CardBody>
        <StatGroup columns={4}>
          <Stat label="Amount" value={formatMoney(detail.invoice_amount, currency)} />
          <Stat label="VAT" value={formatMoney(detail.invoice_vat, currency)} />
          <Stat label="Total" value={formatMoney(detail.invoice_total, currency)} />
          <Stat label="Paid" value={formatMoney(paid, currency)} />
        </StatGroup>
      </CardBody>
    </Card>
  );
}
